<template>
  <v-toolbar
    flat
    dense
  >
    <v-spacer />

    <v-toolbar-items>
      <template v-for="item in items">
        <v-divider
          v-if="item.divider"
          :key="`${item.name}-divider`"
          inset
          vertical
        />

        <v-tooltip
          v-else
          :key="item.name"
          bottom
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              style="pointer-events: auto;"
              :disabled="item.condition ? isDisabled(item.condition) : false"
              v-on="on"
              @click="$emit('action', { action: item.event })"
            >
              <v-icon>{{ item.icon }}</v-icon>
            </v-btn>
          </template>
          <span>{{ item.name }}</span>
        </v-tooltip>
      </template>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    selectedTasks: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      items: [
        {
          name: 'Show tasks list',
          icon: 'visibility',
          event: 'show-tasks'
        },
        // {
        //   name: 'Link tasks',
        //   icon: 'link',
        //   event: 'link-tasks',
        //   condition: [ 2 ]
        // },
        {
          name: 'Indent Task',
          icon: 'format_indent_increase',
          event: 'indent:in',
          condition: [ 1, 1 ]
        },
        {
          name: 'Outdent Task',
          icon: 'format_indent_decrease',
          event: 'indent:out',
          condition: [ 1, 1 ]
        },
        { divider: true },
        {
          name: 'Go to current date',
          icon: 'today',
          event: 'today'
        },
        {
          name: 'Shrink time axis',
          icon: 'zoom_out',
          event: 'zoom:out'
        },
        {
          name: 'Enlarge time axis',
          icon: 'zoom_in',
          event: 'zoom:in'
        }
      ]
    }
  },
  methods: {
    isDisabled (condition) {
      let disabled

      disabled = !(this.selectedTasks.length >= condition[0])

      if (condition.length > 1) {
        disabled = disabled || !(this.selectedTasks.length <= condition[1])
      }

      return disabled
    }
  }
}
</script>

<style>

</style>
